import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EDeleteAllNotificationActionTypes, TDeleteAllNotificationsLoading } from './types';

export const deleteAllLoading: () => TDeleteAllNotificationsLoading =
  actionGenerator<EDeleteAllNotificationActionTypes.Loading>(EDeleteAllNotificationActionTypes.Loading);
